import { FC, useEffect, useState } from 'react'
import { useLayout } from '../../core'

const Footer: FC = () => {
    const { classes } = useLayout()
    const [version, setVersion] = useState<string | null>(null);

    useEffect(() => {
        fetch('/manifest.json')
          .then(response => response.json())
          .then(data => {
            setVersion(data.version.version);
          })
          .catch(error => {
            console.error('Error fetching manifest.json:', error);
          });
      }, []);
    return (
        <div className='footer py-4 d-flex flex-lg-column' id='kt_footer' style={{ background: '#E0E0E0', display: 'flex', flexDirection: 'column', padding:'2.5rem' }}>
            {/* begin::Container */}
            <div
                className={`${classes.footerContainer} d-flex flex-column flex-md-row align-items-center justify-content-between`}
            >
                {/* begin::Copyright */}
                <div className='order-2 order-md-1'>
                    <span className='me-2' style={{ fontWeight: 400, fontSize: 12, color: '#FFFFFF' }}> © Vestel Şirketler Grubu v{version}</span>
                    <a href='#' className='text-gray-800 text-hover-primary'>
                    </a>
                </div>
                {/* end::Copyright */}

                {/* begin::Nav */}
                <label className='menu menu-gray-600 menu-hover-primary mx-1 my-1 fw-bold order-1'>
                    <div className='text-center'>
                        <img
                            src={('/media/logos/VestelBeyaz2.png')}
                        />
                    </div>
                </label>
                {/* end::Nav */}
            </div>
            {/* end::Container */}
        </div>
    )
}

export { Footer }

